import styled from '@emotion/styled';
import UnstyledButton from '@embed/components/common/UnstyledButton';
export const SubsList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;
export const SubsListItem = styled.li `
  border: 1px solid color-mix(in srgb, currentColor 10%, transparent);
  border-radius: var(--radius-3);
  transition: border-color 0.15s ease-in-out;
  ${(props) => (props.current ? 'border-color: var(--primary);' : '')}

  &:hover {
    border-color: var(--primary);
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
export const SubsListItemButton = styled(UnstyledButton) `
  padding: 1em;
  display: block;
  width: 100%;
  text-transform: capitalize;
`;
